<template>
  <div class="box" @click="canvasDisableHighlight();boxSetFormat(format);">
    <div class="box-image">
      <img :src="getImageUrl(format)">
    </div>
    <div class="pull-right">
      <div class="box-title">
        <slot name="title"></slot>
      </div>
      <span class="box-text">
        <slot name="description"></slot>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    format: String,
  },
  methods: {
    getImageUrl(format) {
      const images = require.context('../../../../../assets/img/box/formats/', false, /\.svg$/);

      return images(`./${format}.svg`);
    },
    ...mapActions([
      'boxSetFormat',
      'canvasDisableHighlight',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** GeneralItem.vue?6ad41c8e
 **/